export const AtaiBreakPoints = {
    XS: '(min-width:320px) and (max-width:550px)',
    SM: '(min-width:551px) and (max-width:768px)',
    MD: '(min-width:769px) and (max-width:1024px)',
    XMD: '(min-width:1025px) and (max-width:1200px)',
    LG: '(min-width:1201px) and (max-width:1350px)',
    XLG: '(min-width:1351px) and (max-width:1650px)',
    XXLG: '(min-width:1651px)',
    LG_LT: '(max-width:1350px)',
    XMD_LT: '(max-width:1024px)',
    MD_LT: '(max-width:768px)',
    SM_LT: '(max-width:550px)',
}